module.exports = __webpack_public_path__ + "img/e20e51c.jpg";